/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListSpendRulesSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListSpendRulesSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListSpendRulesSecurity = {
  option1?: ListSpendRulesSecurityOption1 | undefined;
  option2?: ListSpendRulesSecurityOption2 | undefined;
};

export type ListSpendRulesRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListSpendRulesSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListSpendRulesSecurityOption1$outboundSchema: z.ZodMiniType<
  ListSpendRulesSecurityOption1$Outbound,
  ListSpendRulesSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function listSpendRulesSecurityOption1ToJSON(
  listSpendRulesSecurityOption1: ListSpendRulesSecurityOption1,
): string {
  return JSON.stringify(
    ListSpendRulesSecurityOption1$outboundSchema.parse(
      listSpendRulesSecurityOption1,
    ),
  );
}

/** @internal */
export type ListSpendRulesSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListSpendRulesSecurityOption2$outboundSchema: z.ZodMiniType<
  ListSpendRulesSecurityOption2$Outbound,
  ListSpendRulesSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listSpendRulesSecurityOption2ToJSON(
  listSpendRulesSecurityOption2: ListSpendRulesSecurityOption2,
): string {
  return JSON.stringify(
    ListSpendRulesSecurityOption2$outboundSchema.parse(
      listSpendRulesSecurityOption2,
    ),
  );
}

/** @internal */
export type ListSpendRulesSecurity$Outbound = {
  Option1?: ListSpendRulesSecurityOption1$Outbound | undefined;
  Option2?: ListSpendRulesSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListSpendRulesSecurity$outboundSchema: z.ZodMiniType<
  ListSpendRulesSecurity$Outbound,
  ListSpendRulesSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListSpendRulesSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListSpendRulesSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listSpendRulesSecurityToJSON(
  listSpendRulesSecurity: ListSpendRulesSecurity,
): string {
  return JSON.stringify(
    ListSpendRulesSecurity$outboundSchema.parse(listSpendRulesSecurity),
  );
}

/** @internal */
export type ListSpendRulesRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListSpendRulesRequest$outboundSchema: z.ZodMiniType<
  ListSpendRulesRequest$Outbound,
  ListSpendRulesRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function listSpendRulesRequestToJSON(
  listSpendRulesRequest: ListSpendRulesRequest,
): string {
  return JSON.stringify(
    ListSpendRulesRequest$outboundSchema.parse(listSpendRulesRequest),
  );
}
